import React, { Component, useState } from 'react';
import '../../css/pages/settings.css';
import Nav from 'react-bootstrap/Nav';
import { toast } from 'react-toastify';
import { connect } from 'react-redux';
import { message, Upload } from 'antd';
import PinInput from 'react-pin-input';
import TopNav from '../components/TopNav';
import SideNav from '../components/SideNav';
import {
  updateAutoDisbursement, fetchAutoDisbursement, fillUser, updateUser, fetchLenderProfile, updateLenderProfile
} from '../actions/account';
import {
  updatePassword, updatePin, initPINReset, resetPIN,
} from '../actions/auth';
import { getAllStates, getOptions } from '../actions/utils';

class Settings extends Component {
  constructor(props) {
    super(props);
    this.state = {
      active: 'profile',
      active_preference: 'risk',
      sendOTP: true,
      auto_disbursement: {
        enabled: false,
        customer_only: true,
        min_repaid_loans: 2,
        max_amount: 5000,
      },
      locations: {},
      borrower_category: {},
    };
  }

  componentDidMount() {
    this.props.fetchAutoDisbursement();
    this.props.getAllStates();
    this.props.getOptions();
    this.props.fetchLenderProfile();
  }

  fetchLenderDetails = async () => {
    const data = await fetchLenderProfile(); //await fetchLenderProfile().then(({ data: lenderProfile }) => { this.setState({ lenderProfile });});

    this.setState({ lenderProfile: data.data })
  }

  onUploadPhotoImage = (info) => {
    const { fillUser } = this.props;
    this.setState({ loading: 'Processing' }, async () => {
      try {
        if (info.file.status === 'done') {
          if (info?.file?.response?.data?.url) {
            const response = await updateUser({
              photo_url: info?.file?.response?.data?.url,
            });
            if (response.status !== 'success') throw new Error(response?.message);
            toast.success('Uploaded!');
            fillUser(response?.data);
            return;
          }
          toast.error('Image could not be uploaded!');
          return;
        }
      } catch (error) {
        toast.error(error.response?.data?.message || error.response?.statusText
          || error.message
          || 'Seems like something went wrong with your request. Please try again.');
      } finally {
        this.setState({ loading: false });
      }
    });
  };

  handleOnChange = (e) => this.setState({ [e.target.name]: e.target.value });

  handleSubmit = (e) => {
    const { fetchAutoDisbursement } = this.props;
    e.preventDefault();
    this.setState({ loading: 'Processing' }, async () => {
      try {
        const {
          enabled, customer_only, min_repaid_loans, max_amount,
        } = this.state;
        const response = await updateAutoDisbursement({
          enabled, customer_only, min_repaid_loans, max_amount,
        });
        if (response.status !== 'success') throw new Error(response?.message);
        toast.success(response?.message);
        fetchAutoDisbursement();
      } catch (error) {
        toast.error(error.response?.data?.message || error.response?.statusText
          || error.message
          || 'Seems like something went wrong with your request. Please try again.');
      } finally {
        this.setState({ loading: false });
      }
    });
  }

  handleSecuritySubmit = (e) => {
    const { onClose } = this.props;
    e.preventDefault();
    this.setState({ loading: 'Processing' }, async () => {
      try {
        console.log(this.state);
        const response = await updatePassword(this.state);
        if (response.status !== 'success') throw new Error(response?.message);
        toast.success(response?.message);
        onClose?.();
      } catch (error) {
        toast.error(error.response?.data?.message || error.response?.statusText
          || error.message
          || 'Seems like something went wrong with your request. Please try again.');
      } finally {
        this.setState({ loading: false });
      }
    });
  }

  handleSecurityPinSubmit = (e) => {
    const { onClose } = this.props;
    e.preventDefault();
    this.setState({ loading: 'Processing' }, async () => {
      try {
        console.log(this.state);
        const response = await updatePin(this.state);
        if (response.status !== 'success') throw new Error(response?.message);
        toast.success(response?.message);
        onClose?.();
      } catch (error) {
        toast.error(error.response?.data?.message || error.response?.statusText
          || error.message
          || 'Seems like something went wrong with your request. Please try again.');
      } finally {
        this.setState({ loading: false });
      }
    });
  }

  handleSecurityPinReset = (e) => {
    const { onClose } = this.props;
    e.preventDefault();
    this.setState({ loading: 'Processing' }, async () => {
      try {
        console.log(this.state);
        const response = await resetPIN(this.state);
        if (response.status !== 'success') throw new Error(response?.message);
        toast.success(response?.message);
        onClose?.();
      } catch (error) {
        toast.error(error.response?.data?.message || error.response?.statusText
          || error.message
          || 'Seems like something went wrong with your request. Please try again.');
      } finally {
        this.setState({ loading: false });
      }
    });
  }

  handleInitPINReset = (e) => {
    const { onClose } = this.props;
    e.preventDefault();
    this.setState({ loading: 'Processing' }, async () => {
      try {
        const response = await initPINReset(this.state);
        if (response.status !== 'success') throw new Error(response?.message);
        toast.success(response?.message);
        onClose?.();
        this.setState({ sendOTP: false });
      } catch (error) {
        toast.error(error.response?.data?.message || error.response?.statusText
          || error.message
          || 'Seems like something went wrong with your request. Please try again.');
      } finally {
        this.setState({ loading: false });
      }
    });
  }

  handlePreference = (e) => {
    const { onClose } = this.props;
    e.preventDefault();
    this.setState({ loading: 'Processing' }, async () => {
      try {
        // eslint-disable-next-line react/destructuring-assignment
        const locations = Object.keys(this.state.locations)
          .filter((id) => !!id).map((id) => ({ state_id: `${id}` }));
        const borrower_category = Object.keys(this.state.borrower_category)
          .filter((id) => !!id).map((id) => ({ id: `${id}` }));

        const { min_tenor_def_id, max_tenor_def_id, min_tenor_value, max_tenor_value,
          risk_apt_id, min_amount, max_amount,
          max_loan_amount, max_loan_count, is_private, display_name, minimium_credit_score,
          allow_multiple_repayment, repayment_model } = this.state;

        const data = {
          min_tenor_def_id, max_tenor_def_id, min_tenor_value, max_tenor_value,
          risk_apt_id, borrower_category, locations, min_amount, max_amount,
          max_loan_amount, max_loan_count, is_private, display_name, minimium_credit_score,
          allow_multiple_repayment, repayment_model
        };

        const response = await updateLenderProfile(data);
        if (response.status !== 'success') throw new Error(response?.message);
        toast.success(response?.message);
        onClose?.();
      } catch (error) {
        this.setState({ loading: false },
          () => toast.error(error.response?.data?.message || error.response?.statusText
            || error.message
            || 'Seems like something went wrong with your request. Please try again.'));
      }
      finally {
        this.setState({ loading: false });
      }
    });
  }

  render() {
    const {
      active, loading, sendOTP, oldPassword, newPassword, oldPin, newPin, enabled, otp, new_pin, active_preference, locations, borrower_category
    } = this.state;
    const { business, user, auto_disbursement } = this.props;
    const { states, options, lenderProfile } = this.props;
    const borrower_categories = options.find((x) => x.key === 'borrower-category')?.options || [];
    const risk_appetite = options.find((x) => x.key === 'risk-appetite')?.options || [];
    const tenor_types = options.find((x) => x.key === 'tenor-types')?.options || [];

   
    return (
      <>
        <SideNav page="settings" />
        <main className="body-main">
          <div className="body-main__container">
            <TopNav page="settings" />
            <section className="body-main__content">
              <div className="settings">
                <div className="pageTitle d-lg-none">
                  <h3 className="pageTitle__header">Settings</h3>
                </div>
              </div>
              <div className="row">
                <div className="col">
                  <div className="card default-card settings">
                    <Nav
                      onSelect={(selectedKey) => this.setState({ active: selectedKey })}
                      className="nav nav-tabs"
                      as="ul">
                      <Nav.Item as="li" className="nav-item">
                        <Nav.Link className={`nav-link ${active === 'profile' ? 'active' : ''}`} eventKey="profile">
                          Profile
                        </Nav.Link>
                      </Nav.Item>
                      <Nav.Item as="li" className="nav-item">
                        <Nav.Link className={`nav-link ${active === 'info' ? 'active' : ''}`} eventKey="info">
                          Business Info
                        </Nav.Link>
                      </Nav.Item>
                      {(user.type !== 'initiator'
                      && (
                      <Nav.Item as="li" className="nav-item">
                        <Nav.Link className={`nav-link ${active === 'preferences' ? 'active' : ''}`} eventKey="preferences">
                          Preferences
                        </Nav.Link>
                      </Nav.Item>
                      ))}
                      <Nav.Item as="li" className="nav-item" hidden>
                        <Nav.Link className={`nav-link ${active === 'docs' ? 'active' : ''}`} eventKey="docs">
                          Business Documents
                        </Nav.Link>
                      </Nav.Item>
                      {(user.type !== 'initiator'
                      && (
                      <Nav.Item as="li" className="nav-item">
                        <Nav.Link className={`nav-link ${active === 'auto' ? 'active' : ''}`} eventKey="auto">
                          Auto Disbursement
                        </Nav.Link>
                      </Nav.Item>
                      ))}
                      <Nav.Item as="li" className="nav-item">
                        <Nav.Link className={`nav-link ${active === 'security' ? 'active' : ''}`} eventKey="security">
                          Security
                        </Nav.Link>
                      </Nav.Item>
                      <Nav.Item as="li" className="nav-item" hidden>
                        <Nav.Link className={`nav-link ${active === 'reset_pin' ? 'active' : ''}`} eventKey="reset_pin" onClick={this.handleInitPINReset}>
                          Reset PIN
                        </Nav.Link>
                      </Nav.Item>
                    </Nav>
                    <div className="tab-content" id="myTabContent">
                      <div className={`tab-pane fade ${active === 'profile' ? 'show active' : ''}`}>
                        <div className="profile__content">
                          <form action="">
                            <div>
                              <div className="form-group">
                                <label htmlFor="businessName" className="form-label">Name</label>
                                <input
                                  type="text"
                                  className="form-control"
                                  defaultValue={user?.first_name + ' ' + user?.last_name}
                                  disabled />
                              </div>
                              <div className="form-group">
                                <label htmlFor="businessAddress" className="form-label">Phone Number</label>
                                <input
                                  type="text"
                                  className="form-control"
                                  defaultValue={user?.phone_number}
                                  disabled />
                              </div>
                              <div className="form-group">
                                <label htmlFor="businessEmail" className="form-label">Email Address</label>
                                <input
                                  type="email"
                                  className="form-control"
                                  defaultValue={user?.email}
                                  disabled />
                              </div>
                            </div>
                            <div className="buttonCTA">
                              <button type="submit" className="btn btn-primary w-100" disabled>Save Changes</button>
                            </div>
                          </form>
                          <div className="changeLogo">
                            <div className="profile-picture">
                              {user?.photo_url ? (
                                <a
                                  href={user?.photo_url}
                                  target="_blank"
                                  rel="noreferrer"
                                  className="image-container">
                                  <img src={user?.photo_url} alt="" />
                                </a>
                              ) : (
                                <a href="/#" className="image-container emptyImageContainer">
                                  <span>{user?.first_name?.[0] || ''}</span>
                                </a>
                              )}
                            </div>
                            <div className="changeLogo__text">
                              <Upload onChange={this.onUploadPhotoImage} showUploadList={false} maxCount={1} action="https://api.p2vest.com/v1/util/upload/photo">
                                <a className="btn btn-link upload-btn">
                                  <span className="filename" id="fileDescription">Change Avatar</span>
                                </a>
                              </Upload>
                            </div>
                          </div>
                        </div>
                      </div>
                      <div className={`tab-pane fade ${active === 'info' ? 'show active' : ''}`}>
                        <div className="businessInfo__content">
                          <form action="">
                            <div>
                              <div className="form-group">
                                <label htmlFor="businessId" className="form-label">Business ID</label>
                                <input
                                  type="text"
                                  className="form-control"
                                  name="businessId"
                                  value={business?.id || ''}
                                  disabled={business?.id}
                                  onChange={this.handleOnChange} />
                              </div>
                              <div className="form-group">
                                <label htmlFor="businessName" className="form-label">Business Name</label>
                                <input
                                  type="text"
                                  className="form-control"
                                  name="businessName"
                                  value={business?.name || ''}
                                  disabled={business?.name}
                                  onChange={this.handleOnChange} />
                              </div>
                              <div className="form-group">
                                <label htmlFor="businessAddress" className="form-label">Business Address</label>
                                <textarea
                                  type="text"
                                  className="form-control"
                                  name="businessAddress"
                                  defaultValue={business?.address || ''}
                                  disabled
                                  onChange={this.handleOnChange}>
                                </textarea>
                              </div>
                              <div className="form-group">
                                <label htmlFor="businessEmail" className="form-label">Business Email Address</label>
                                <input
                                  type="email"
                                  className="form-control"
                                  name="businessEmail"
                                  value={business?.support_email || ''}
                                  disabled={business?.support_email}
                                  onChange={this.handleOnChange} />
                              </div>
                              <div className="form-group">
                                <label htmlFor="businessPhone" className="form-label">Business Phone Number</label>
                                <input
                                  type="number"
                                  className="form-control"
                                  name="businessPhone"
                                  defaultValue={business?.support_phone || ''}
                                  disabled={business?.support_phone}
                                  onChange={this.handleOnChange} />
                              </div>
                              <div className="form-group">
                                <label htmlFor="regNo" className="form-label">Business Registration Number</label>
                                <input
                                  type="text"
                                  className="form-control"
                                  defaultValue={business?.registration_number || ''}
                                  disabled={!!business?.registration_number}
                                  name="registration_number"
                                  onChange={this.handleOnChange} />
                              </div>
                              <div className="form-group">
                                <label htmlFor="regDate" className="form-label">Date of Registration</label>
                                <input
                                  type="date"
                                  className="form-control"
                                  defaultValue={business?.registration_date?.split('T')[0] || ''}
                                  disabled={!!business?.registration_date}
                                  name="registration_date"
                                  onChange={this.handleOnChange} />
                              </div>
                            </div>
                            <div className="buttonCTA">
                              <button
                                type="submit"
                                className="btn btn-primary w-100"
                                disabled>
                                Save Changes
                              </button>
                            </div>
                          </form>
                        </div>
                      </div>
                      <div className={`tab-pane fade ${active === 'preferences' ? 'show active' : ''}`}>
                        <Nav
                          onSelect={(selectedKey) => this.setState({ active_preference: selectedKey })}
                          className="nav nav-tabs"
                          as="ul">
                          <Nav.Item as="li" className="nav-item">
                            <Nav.Link className={`nav-link ${active_preference === 'risk' ? 'active' : ''}`} eventKey="risk">
                              Risk Appetite
                            </Nav.Link>
                          </Nav.Item>
                          <Nav.Item as="li" className="nav-item">
                            <Nav.Link className={`nav-link ${active_preference === 'tenor' ? 'active' : ''}`} eventKey="tenor">
                              Tenor Range
                            </Nav.Link>
                          </Nav.Item>
                          <Nav.Item as="li" className="nav-item">
                            <Nav.Link className={`nav-link ${active_preference === 'borrower_preferences' ? 'active' : ''}`} eventKey="borrower_preferences">
                              Borrower Preferences
                            </Nav.Link>
                          </Nav.Item>
                          <Nav.Item as="li" className="nav-item" hidden>
                            <Nav.Link className={`nav-link ${active_preference === 'profile_visibility' ? 'active' : ''}`} eventKey="profile_visibility">
                              Profile Visibility
                            </Nav.Link>
                          </Nav.Item>
                        </Nav>
                        <div className="tab-content" id="myTabContent2">
                          <div className={`tab-pane fade ${active_preference === 'risk' ? 'show active' : ''}`}>
                            <div className="">
                              <form action="" onSubmit={this.handlePreference}>
                                <div>
                                  <div className="form-group">
                                    <label htmlFor="businessName" className="form-label">How would you rate your risk tolerance</label>
                                    <select className="form-control" id="risk_apt_id" name="risk_apt_id" defaultValue={lenderProfile?.risk_appetite || 0}>
                                      <option>Select option</option>
                                      {risk_appetite.map((o) =>
                                        <option value={o?.id}>{o?.code_description}</option>
                                      )}
                                    </select>
                                  </div>
                                  <div className="form-group">
                                    <label htmlFor="min_amount" className="form-label">Minimum individual loan amount (₦)</label>
                                    <input
                                      type="number"
                                      className="form-control"
                                      id="min_amount"
                                      name="min_amount"
                                      defaultValue={lenderProfile?.min_amount || 0}
                                      onChange={this.handleOnChange} />
                                  </div>
                                  <div className="form-group">
                                    <label htmlFor="max_amount" className="form-label">Maximum individual loan amount (₦)</label>
                                    <input
                                      type="number"
                                      className="form-control"
                                      id="max_amount"
                                      name="max_amount"
                                      defaultValue={lenderProfile?.max_amount || 0}
                                      onChange={this.handleOnChange} />
                                  </div>
                                  <div className="form-group">
                                    <label htmlFor="max_loan_count" className="form-label">Maximum number of active loans</label>
                                    <input
                                      type="number"
                                      className="form-control"
                                      id="max_loan_count"
                                      name="max_loan_count"
                                      defaultValue={lenderProfile?.max_loan_count || 0}
                                      onChange={this.handleOnChange} />
                                  </div>
                                  <div className="form-group">
                                    <label htmlFor="max_loan_amount" className="form-label">Maximum cumulative loan amount</label>
                                    <input
                                      type="number"
                                      className="form-control"
                                      id="max_loan_amount"
                                      name="max_loan_amount"
                                      defaultValue={lenderProfile?.max_loan_amount || 0}
                                      onChange={this.handleOnChange} />
                                  </div>
                                  <div className="form-group">
                                    <label htmlFor="minimium_credit_score" className="form-label">Minimum credit score for borrowers</label>
                                    <input
                                      type="number"
                                      className="form-control"
                                      id="minimium_credit_score"
                                      name="minimium_credit_score"
                                      defaultValue={lenderProfile?.minimium_credit_score || 0}
                                      onChange={this.handleOnChange} />
                                  </div>
                                </div>
                                <div className="buttonCTA">
                                  <button type="submit" className="btn btn-primary w-100">Save Changes</button>
                                </div>
                              </form>
                            </div>
                          </div>
                          <div className={`tab-pane fade ${active_preference === 'tenor' ? 'show active' : ''}`}>
                            <div className="">
                              <form action="" onSubmit={this.handlePreference}>
                                <div className="form-group">
                                  <label htmlFor="min_tenor_value" className="form-label">Minimum Loan Tenor</label>
                                  <input
                                    type="number"
                                    className="form-control"
                                    id="min_tenor_value"
                                    name="min_tenor_value"
                                    defaultValue={lenderProfile?.min_tenor_value || 0}
                                    onChange={this.handleOnChange} />
                                </div>
                                <div className="form-group">
                                  <div className="input-with-icon">
                                    <select
                                      className="form-control"
                                      id="min_tenor_def_id"
                                      name="min_tenor_def_id"
                                      defaultValue={lenderProfile?.min_tenor_type || 0}
                                      onChange={this.handleOnChange}>
                                      <option disabled selected>Tenor type</option>
                                      {tenor_types.map((o) =>
                                        <option value={o?.id}>{o?.code_description}</option>
                                      )}
                                    </select>
                                  </div>
                                </div>
                                <div className="form-group">
                                  <label htmlFor="max_tenor_value" className="form-label">Maximum Tenor</label>
                                  <input
                                    type="number"
                                    className="form-control"
                                    id="max_tenor_value"
                                    name="max_tenor_value"
                                    defaultValue={lenderProfile?.max_tenor_value || 0}
                                    onChange={this.handleOnChange} />

                                </div>
                                <div className="form-group">
                                  <div className="input-with-icon">
                                    <select
                                      className="form-control"
                                      id="max_tenor_def_id"
                                      name="max_tenor_def_id"
                                      defaultValue={lenderProfile?.max_tenor_type || 0}
                                      onChange={this.handleOnChange}>
                                      <option disabled selected>Tenor type</option>
                                      {tenor_types.map((o) =>
                                        <option value={o?.id}>{o?.code_description}</option>
                                      )}
                                    </select>
                                  </div>
                                </div>
                                <div className="buttonCTA">
                                  <button type="submit" className="btn btn-primary w-100">Save Changes</button>
                                </div>
                              </form>
                            </div>
                          </div>
                          <div className={`tab-pane fade ${active_preference === 'borrower_preferences' ? 'show active' : ''}`}>
                            <div className="">
                              <form action="" onSubmit={this.handlePreference}>
                                <div>
                                  <div className="form-group">
                                    <label htmlFor="businessName" className="form-label">What locations do you want your borrowers to come from? (Select all that apply)</label>
                                    <div className="checker card-checker my-3">
                                      <label className="check-ticker">
                                        <div className="card-check__value">
                                          <input
                                            type="checkbox"
                                            className="check-ticker-input"
                                            onChange={(e) => this.setState({
                                              locations: states.reduce((acc, cat) => {
                                                acc[cat.id] = e.target.checked;
                                                return acc;
                                              }, {}),
                                            })} />
                                          <span className="check-ticker__tick"></span>
                                          <span>All States</span>
                                        </div>
                                      </label>
                                    </div>
                                    {states.map((o) => (
                                      <label key={o.id} className="check-ticker flex-wrap w-auto p-1">
                                        <div className="card-check__value">
                                          <input
                                            type="checkbox"
                                            className="check-ticker-input"
                                            checked={!!locations[o.id]}
                                            onChange={() => this.setState({
                                              locations: { ...locations, [o.id]: !locations[o.id] },
                                            })} />
                                          <span className="check-ticker__tick mx-2"></span>
                                          <span>{o.code_description}</span>
                                        </div>
                                      </label>
                                    ))}
                                  </div>
                                  <div className="form-group">
                                    <label>Categories of borrowers (Select all that apply)</label>
                                    {borrower_categories.map((o) => (
                                      <div className="form-group" key={o.id}>
                                        <div className="checker card-checker">
                                          <label className="check-ticker">
                                            <div className="card-check__value">
                                              <input
                                                type="checkbox"
                                                className="check-ticker-input"
                                                checked={!!borrower_category[o.id]}
                                                onChange={() => this.setState({
                                                  borrower_category: {
                                                    ...borrower_category, [o.id]: !borrower_category[o.id],
                                                  },
                                                })} />
                                              <span className="check-ticker__tick"></span>
                                              <span>{o.code_description}</span>
                                            </div>
                                          </label>
                                        </div>
                                      </div>
                                    ))}
                                  </div>
                                </div>
                                <div className="buttonCTA">
                                  <button type="submit" className="btn btn-primary w-100" >Save Changes</button>
                                </div>
                              </form>
                            </div>
                          </div>
                        </div>
                      </div>
                      <div className={`tab-pane fade ${active === 'docs' ? 'show active' : ''}`} hidden>
                        <div className="businessDoc__content">
                          <div className="businessDoc__content--section">
                            <h6 className="title">
                              CAC Incorporation Document
                            </h6>
                            <p className="subtext">
                              Your document is currently under review.
                            </p>
                          </div>
                          <div className="businessDoc__content--section">
                            <h6 className="title">
                              Identification (ID)
                            </h6>
                            <p className="subtext">
                              You can view your means of identification
                              {' '}
                              <a href="">here</a>
                              .
                            </p>
                          </div>
                          <div className="businessDoc__content--section">
                            <h6 className="title">
                              Lending License
                            </h6>
                            <p className="subtext">
                              Upload your lending license if you have one.
                            </p>
                            <button className="btn btn-outline-primary upload-bstn" type="button">
                              <input type="file" className="form-control-file" id="uploadLicense" />
                              <label htmlFor="uploadLicense">
                                <span className="filename" id="fileDescription">Upload License</span>
                                {/* Upload License */}
                              </label>
                            </button>
                          </div>
                        </div>
                      </div>
                      <div className={`tab-pane fade ${active === 'auto' ? 'show active' : ''}`}>
                        <div className="businessInfo__content">
                          <form action="" onSubmit={this.handleSubmit}>
                            <div>
                              <div className="form-group">
                                <div className="checker card-checker">
                                  <label className="check-ticker">
                                    <div className="card-check__value">
                                      <input
                                        type="checkbox"
                                        className="check-ticker-input"
                                        name="enabled"
                                        defaultChecked={auto_disbursement?.enabled || false}
                                        onChange={() => {
                                          this.setState({ enabled: !auto_disbursement?.enabled });
                                        }} />
                                      <span className="check-ticker__tick"></span>
                                      <span>Enabled</span>
                                    </div>
                                  </label>
                                </div>
                              </div>
                              <div className="form-group">
                                <label htmlFor="max_amount" className="form-label">Max Loan Amount</label>
                                <input
                                  type="number"
                                  className="form-control"
                                  name="max_amount"
                                  defaultValue={auto_disbursement?.max_amount}
                                  onChange={this.handleOnChange} />
                              </div>
                              <div className="form-group">
                                <label htmlFor="min_repaid_loans" className="form-label">Borrower&#39;s Minimum repaid loans</label>
                                <input
                                  type="text"
                                  className="form-control"
                                  name="min_repaid_loans"
                                  defaultValue={auto_disbursement?.min_repaid_loans}
                                  onChange={this.handleOnChange} />
                              </div>
                              <div className="form-group">
                                <div className="checker card-checker">
                                  <label className="check-ticker">
                                    <div className="card-check__value">
                                      <input
                                        type="checkbox"
                                        className="check-ticker-input"
                                        name="customer_only"
                                        defaultChecked={auto_disbursement?.customer_only || false}
                                        onChange={() => {
                                          this.setState({
                                            customer_only: !auto_disbursement?.customer_only,
                                          });
                                        }} />
                                      <span className="check-ticker__tick"></span>
                                      <span>Auto disburse to only customers.</span>
                                    </div>
                                  </label>
                                </div>
                              </div>
                            </div>
                            <div className="buttonCTA">
                              <button
                                type="submit"
                                disabled={loading}
                                className="btn btn-primary w-100">
                                {loading || 'Save Changes'}
                              </button>
                            </div>
                          </form>
                        </div>
                      </div>
                      <div className={`tab-pane fade ${active === 'security' ? 'show active' : ''}`}>
                        <div className="security-pane__content">
                          <div className="row">
                            <div className="col-md-6">
                              <form onSubmit={this.handleSecuritySubmit}>
                                <div>
                                  <div style={{ textAlign: "center" }}>Change Password</div>
                                  <div className="form-group">
                                    <label htmlFor="oldPassword" className="form-label">Old Password</label>
                                    <div className="input-with-icon">
                                      <input type="password" className="form-control" id="oldPassword" name="oldPassword" onChange={this.handleOnChange} />
                                      <span className="input-icon" id="toggle-icon">
                                        <svg width="20" height="20">
                                          <use xlinkHref="../../assets/icon-sprite.svg#eye-closed"></use>
                                        </svg>
                                        <svg width="20" height="20" hidden>
                                          <use xlinkHref="../../assets/icon-sprite.svg#eye-close-icon"></use>
                                        </svg>
                                      </span>
                                    </div>
                                    <div className="form-text error-message">
                                      <p>Old Password is required.</p>
                                    </div>
                                  </div>
                                  <div className="form-group">
                                    <label htmlFor="newPassword" className="form-label">New Password</label>
                                    <div className="input-with-icon">
                                      <input type="password" className="form-control" id="newPassword" name="newPassword" onChange={this.handleOnChange} />
                                      <span className="input-icon" id="toggle-icon">
                                        <svg width="20" height="20">
                                          <use xlinkHref="../../assets/icon-sprite.svg#eye-closed"></use>
                                        </svg>
                                        <svg width="20" height="20" hidden>
                                          <use xlinkHref="../../assets/icon-sprite.svg#eye-close-icon"></use>
                                        </svg>
                                      </span>
                                    </div>
                                    <div className="form-text error-message">
                                      <p>New Password is required.</p>
                                    </div>
                                  </div>
                                </div>
                                <div className="buttonCTA">
                                  <button
                                    type="submit"
                                    disabled={!newPassword || !oldPassword || loading}
                                    className="btn btn-primary w-100">
                                    {loading || 'Update Password'}
                                  </button>
                                </div>
                              </form>
                            </div>
                            <div className="col-md-6">
                              <form onSubmit={this.handleSecurityPinSubmit}>
                                <div>
                                  <div style={{ textAlign: "center" }}>Change Pin</div>
                                  <div className="form-group">
                                    <label htmlFor="oldPin" className="form-label">Old PIN</label>
                                    <div className="input-with-icon">
                                      <input type="password" minLength="4" maxLength="4" className="form-control" id="oldPin" name="oldPin" onChange={this.handleOnChange} />
                                      <span className="input-icon" id="toggle-icon">
                                        <svg width="20" height="20">
                                          <use xlinkHref="../../assets/icon-sprite.svg#eye-closed"></use>
                                        </svg>
                                        <svg width="20" height="20" hidden>
                                          <use xlinkHref="../../assets/icon-sprite.svg#eye-close-icon"></use>
                                        </svg>
                                      </span>
                                    </div>
                                    <div className="form-text error-message">
                                      <p>Old PIN is required.</p>
                                    </div>
                                  </div>
                                  <div className="form-group">
                                    <label htmlFor="newPin" className="form-label">New PIN</label>
                                    <div className="input-with-icon">
                                      <input type="password" minLength="4" maxLength="4" className="form-control" id="newPin" name="newPin" onChange={this.handleOnChange} />
                                      <span className="input-icon" id="toggle-icon">
                                        <svg width="20" height="20">
                                          <use xlinkHref="../../assets/icon-sprite.svg#eye-closed"></use>
                                        </svg>
                                        <svg width="20" height="20" hidden>
                                          <use xlinkHref="../../assets/icon-sprite.svg#eye-close-icon"></use>
                                        </svg>
                                      </span>
                                    </div>
                                    <div className="form-text error-message">
                                      <p>New PIN is required.</p>
                                    </div>
                                  </div>
                                </div>
                                <div className="buttonCTA">
                                  <button
                                    type="submit"
                                    disabled={!newPin || !oldPin || loading}
                                    className="btn btn-primary w-100">
                                    {loading || 'Update PIN'}
                                  </button>
                                </div>
                              </form>
                            </div>
                          </div>
                        </div>
                        <br />
                        <br />
                        <div className="security-pane__content">
                          <div className="row">
                            <div className="col-md-6">
                              <div style={{ textAlign: "center" }}>Reset Pin</div>
                              <br />
                              <br />
                              <form onSubmit={this.handleSecurityPinReset}>
                                <p>
                                  Please enter the One Time Password that has
                                  {' '}
                                  been sent to your registered phone number.
                                  <span
                                    style={{ color: '#89CFF0', cursor: 'pointer' }}
                                    onClick={this.handleInitPINReset}>
                                    Resend OTP
                                  </span>
                                </p>
                                <label htmlFor="otp" className="form-label">Enter the 6-digit code</label>
                                <PinInput
                                  length={6}
                                  focus={false}
                                  secret
                                  type="numeric"
                                  inputStyle={{ borderColor: '#00AEEF' }}
                                  onChange={(otp) => {
                                    this.setState({ otp });
                                  }} />

                                <br />
                                <br />
                                <label htmlFor="pin" className="form-label">
                                  Recover and set a new PIN
                                  <br />
                                  Enter a new 4-digit PIN
                                </label>
                                <PinInput
                                  length={4}
                                  focus={false}
                                  secret
                                  type="numeric"
                                  inputStyle={{ borderColor: '#00AEEF' }}
                                  onChange={(new_pin) => {
                                    this.setState({ new_pin });
                                  }} />
                                <div className="buttonCTA">
                                  {sendOTP && (
                                    <button
                                      type="button"
                                      className="btn btn-primary w-100"
                                      onClick={(e) => this.handleInitPINReset(e)}>
                                      {loading || 'Initiate Reset Pin'}
                                    </button>
                                  )}
                                  {!sendOTP && (
                                    <button
                                      type="submit"
                                      disabled={!new_pin || new_pin?.length < 4 || !otp || otp.length < 6 || loading}
                                      className="btn btn-primary w-100">
                                      {loading || 'Update PIN'}
                                    </button>
                                  )}

                                </div>
                              </form>
                            </div>
                          </div>
                        </div>
                      </div>
                      <div className={`tab-pane fade ${active === 'reset_pin' ? 'show active' : ''}`} hidden>
                        <div className="security-pane__content">

                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </section>
          </div>
        </main>
      </>
    );
  }
}

const mapStateToProps = (state) => ({
  business: state.account?.business || {},
  user: state.account?.user || {},
  auto_disbursement: state.account?.auto_disbursement || {},
  states: state.utils?.states || [],
  options: state.utils?.options || [],
  lenderProfile: state.account.lenderProfile || {}
});

const mapDispatchToProps = {
  fetchAutoDisbursement,
  fillUser,
  getAllStates,
  getOptions,
  fetchLenderProfile,
};

export default connect(
  mapStateToProps,
  mapDispatchToProps,
)(Settings);
